export const weddingWebsiteData = {
  invitations: {
    eyebrow: 'Your Wedding Website',
    title: 'Your wedding website is also the center of RSVP.',
    mobileTitle: 'Your invites connect to a matching wedding website. ',
    body: `Guests can easily RSVP right on your website, in the same place they’ll find all the wedding details they’ll need to know, customized just for them.`,
    mobileBody: 'Your guests RSVP will right on your wedding website where they’ll find everything about your ceremony. ',
    explore: 'Explore Design Templates',
    learnMore: 'Learn More',
  },
  saveTheDates: {
    eyebrow: 'Your Wedding Website',
    title: 'Save the date and share your beautiful matching website.',
    body:
      'Your Save the Dates come with a free matching website<br/>so you can show off your engagement photos, videos, love story, and more.',
    mobileBody: 'Your guests can easily find all they’ll need to know for the big day.',
    explore: 'Explore Design Templates',
    learnMore: 'Learn More',
  },
  // TODO: rename and fix typo here.
  registeries: {
    eyebrow: 'Your Wedding Website',
    title: 'A wedding website that brings more to the party.',
    body: `Your registries are all right on your website, along with pages for all your wedding details, wrapped in a beautiful design.`,
    explore: 'Explore Design Templates',
    learnMore: 'Learn More',
  },
  guestList: {
    eyebrow: 'Your Wedding Website',
    title: ' The wedding website that does more.',
    body: 'Share everything your guests need to know for your big day, from your event schedule and FAQs, to your gift registry.',
    explore: 'Explore Design Templates',
    learnMore: 'Learn More',
  },
} as const;
